import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Divider } from '@mui/material';

import { hasHangerUpgradeAndAnalyzeFeatureFlag, hasTrussDesignPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { lockIndividualHangers } from '../../../../store/actions/lockOptionsActions';
import { handleStandardSceneItemEditPropertiesAction } from '../../../../store/actions/sceneInteractionActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';

export function HangerMenu(props: { guid: string }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const allowLocking = useAppSelector(hasHangerUpgradeAndAnalyzeFeatureFlag);

  const canEditTrusses = useAppSelector(hasTrussDesignPermission);
  const componentDesign = useAppSelector(getActiveComponentDesign);
  if (componentDesign == null || !canEditTrusses) return null;

  const hanger = componentDesign.component.hangers.find(({ guid }) => guid === props.guid);
  if (!hanger) return null;

  const locked = componentDesign.hangersLocked || componentDesign.lockedHangers.includes(props.guid);

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Edit Properties"
        icon={<EditIcon />}
        onClick={async () => {
          await dispatch(handleStandardSceneItemEditPropertiesAction('hanger', hanger));
          monitor.recordInteraction('Hanger => Edit Properties menu item clicked');
        }}
      />

      <Divider />

      {allowLocking && (
        <SceneMenuItem
          text={`${locked ? 'Unlock' : 'Lock'} Hanger`}
          icon={locked ? <LockOpenIcon /> : <LockIcon />}
          onClick={() => {
            dispatch(lockIndividualHangers(!locked, props.guid));
            monitor.recordInteraction('Hanger => Lock Hanger menu item clicked');
          }}
        />
      )}

      <DeleteMenuItem type="hanger" item={hanger} />
    </SceneMenuContent>
  );
}
